var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressAnsDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:none;stroke:#40485f;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "6.23,14.1 10.6,15.84 7.98,16.72 12.35,19.34  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "11.47,6.23 14.97,9.73 11.47,9.73 14.97,14.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "38.55,6.23 35.06,9.73 38.55,9.73 35.06,14.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "43.79,14.1 39.43,15.84 42.92,17.59 38.55,19.34  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.72,17.59c0,0,3.49-7.86,8.74-6.99c0,0,6.11,0.87,7.86,6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.34,27.2c0,0,0.87-2.62,0-4.37c0-0.87,0-1.75,0.87-3.49s-0.87-3.49-2.62-2.62 c-0.87,0.87-4.37,2.62-2.62,7.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.97,24.58L7.98,36.81c0,0-2.62,3.49,0,5.24c0.87,0.87,4.37,2.62,6.11-0.87l5.24-13.98L14.97,24.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.05,35.06c4.37,5.24,0,7.86,0,7.86c-5.24,3.49-6.99-2.62-6.99-2.62l-5.24-13.1l6.11-2.62l2.62,5.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.37,26.74c0,0-1.55-2.16-0.68-3.9c0-1.75,0-2.62-0.87-4.37c0,0,0-3.49,3.49-0.87 c1.75,1.75,3.49,2.62,2.62,6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.21,18.46c0,0,1.75-1.75,3.49-1.75c0.87,0.87,3.84,3.41,6.73,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.46,28.95c0,0,6.22,6.57,12.28,0.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,28.07c0,0,0.87-1.75,2.62,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 21.96,
    y1: 24.58,
    x2: 23.7,
    y2: 23.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 28.07,
    y1: 24.58,
    x2: 26.32,
    y2: 23.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.96,31.57c0,0,0.54,2.81-4.97,2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.07,31.14c0,0,0.7,3.56,4.72,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.29,33.5c0,0,4.41,5.02,9.59,0.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 13.22,
    y1: 42.05,
    x2: 36.4,
    y2: 42.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 40.3,
    cy: 32.44,
    r: 0.87
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressAnsDisable);
export default __webpack_public_path__ + "static/media/stress-ans-disable.b628230395059b87bb37b1978bf14097.svg";
export { ForwardRef as ReactComponent };